import { Flex, Box } from "@chakra-ui/react"
import SettingsLayout from "components/shared/layouts/SettingsLayout"
import LanguageSettingsHeader from "./LanguageSettingsHeader"
import LanguageSettingsContent from "./LanguageSettingsContent"
import Searchbar from "components/UI/molecules/Searchbar"
import AddLanguageModal from "components/shared/modals/AddLanguageModal"
import { useLanguageSettings } from "providers/LanguageSettingsProvider/LanguageSettingsProvider"

const LanguageSettingsTemplate = () => {
 const { searchValue, handleSearchChange } = useLanguageSettings()

  return (
    <SettingsLayout withCompanyBranches={false} >
      <Flex flexDirection={"column"} w="100%"  borderRadius="10px"  backgroundColor={"white"}>
          <LanguageSettingsHeader/>
          <Box mb="30px" mt="30px" alignSelf="flex-end">
            <Searchbar
              value={searchValue}
              onChange={handleSearchChange}
            />
          </Box>
          <LanguageSettingsContent/>
          <AddLanguageModal />
      </Flex>
    </SettingsLayout>
       
  )
}

export default LanguageSettingsTemplate
